import React, { useState, Component } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ProductList from '../ProductList';
import OrderList from '../OrderList';
import ProductCategory from '../ProductCategory';
import CreateOrder from '../CreateOrder';
import OrderRequestList from '../OrderRequestList';

function OrderRequestTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box >{children}</Box>
      )}
    </div>
  );
}

OrderRequestTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));


export default function SimpleTab(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(3);
    const [opened, setOpened] = React.useState(false);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const togglemenu = (e) => {
        setOpened(!opened);
     }
    return (
      <div className={classes.root} style={{alignItems:"center"}}>
        <div className="wrapper">
        <div className="main_content">
        <AppBar position="static" style={{background:"#ffffff"}}>
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" 
            color="black" indicatorColor="primary" textColor="primary">
            <Tab label="Products" {...a11yProps(0)} />
            <Tab label="Orders" {...a11yProps(1)} />
            <Tab label="Category" {...a11yProps(2)} />
            <Tab label="Order Request" {...a11yProps(3)} />
            <Tab label="Create Order" {...a11yProps(4)} />
          </Tabs>
        </AppBar>
        <OrderRequestTabPanel value={value} index={0}>
          <ProductList />
        </OrderRequestTabPanel>
        <OrderRequestTabPanel value={value} index={1}>
          <OrderList />
        </OrderRequestTabPanel>
        <OrderRequestTabPanel value={value} index={2}>
          <ProductCategory />
        </OrderRequestTabPanel>
        <OrderRequestTabPanel value={value} index={3}>
          <OrderRequestList />
        </OrderRequestTabPanel>
        <OrderRequestTabPanel value={value} index={4}>
          <CreateOrder />
        </OrderRequestTabPanel>
        </div>
      </div>
      </div>
    );
  }
  